import React, { Component } from 'react';
import { Collapse,Tree,Flex,Switch } from 'antd';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import './LayerTree.scss';
import ClusterLayer from '../../layerManager/ClusterLayer';
import layerApi from '../../api/layerApi';
import L from 'leaflet';
// import GridLayer from '../../layerManager/GridLayer';
// import WmsLayer from '../../layerManager/WmsLayer';
import context from '../../context';
const Panel = Collapse.Panel;
const { TreeNode } = Tree;
export default class LayerTree extends Component {
    constructor(props) {
        super(props)
        this.state = {
            expand: false,
            checkedKeys:["region"],
            treeData: context.appConfig.layer||[]
        }
        this.stateProxy = props.stateProxy;
    }
    componentDidMount() {
    }
    componentDidUpdate() {

    }
    componentWillUnmount() {

    }
    onChange = (e) => {
        let { expand } = this.state;
        this.setState({ expand: !expand })
    }
    onSelect = (e) => {
    }
    onCheck = (checkedKeys, e) => {
        // console.log(checkedKeys, e);
        const {stateProxy} = this.state;
        stateProxy.operateItems(checkedKeys);
    }

    _onLabelShowChange = (e) => {
    }

    _titleRender = (e) => {
        const {key, title, label} = e;
        if (label) {
            // const showLayers = this.stateProxy.getShowLayers() || [];
            return <Flex justify="space-between">
                <div>{title}</div>
                <div className="layer-label" onClick={e=> e.stopPropagation()}>
                    {label.alias}
                    <Switch checked={label.show} size="small"
                            onChange={(e) => this._onLabelShowChange(e, key)}/>
                </div>
            </Flex>
        } else {
            return title;
        }
    }

    renderTreeNodes =(data)=>{
        return data.filter(item => item.visible !== false) // 过滤掉隐藏的节点
        .map(item => (
          <TreeNode title={this._titleRender(item)} key={item.key}>
            {item.children && this.renderTreeNodes(item.children)}
          </TreeNode>
        ))
    }
    render() {
        let { expand, treeData } = this.state;
        return (
            <div id="LayerTree">
                <Collapse expandIcon={() => { return expand ? <PlusOutlined /> : <MinusOutlined /> }} onChange={this.onChange}>
                    <Panel header="" key="0">
                        <Tree
                            checkable
                            // defaultExpandedKeys={['0']}
                            // defaultSelectedKeys={['0']}
                            // defaultCheckedKeys={['0']}
                            onSelect={this.onSelect}
                            onCheck={this.onCheck}
                            // treeData={treeData}
                        >
                            {this.renderTreeNodes(treeData)}
                        </Tree>
                    </Panel>
                </Collapse>
            </div>
        )
    }
}
